import { parseTassetUid, Tasset, TassetSchema } from '../../Finance/models/Tasset'
import { getFinder, getInserter, getName } from 'src/util/src/zod'

export const allTassets: Tasset[] = []

export const addTasset = getInserter<Tasset>(getName(TassetSchema), TassetSchema, parseTassetUid, allTassets)

export const findTasset = getFinder(parseTassetUid, allTassets)

export const LSTAR = addTasset({
  id: 'LSTAR',
  name: 'Letmespeak',
  ticker: 'LSTAR',
})
